export function normalizeSymbol(value) {
    if (!value) return null;

    const s = String(value).trim().toUpperCase();

    // erlaubt RHM, HAG, SAP, BMW, NVDA, RHM.DE, BRK.B
    if (!/^[A-Z0-9.-]+$/.test(s)) return null;

    // mindestens 3 Zeichen
    if (s.length < 3) return null;

    return s;
}

export function isValidSymbol(symbol) {
    if (!symbol) return false;

    const s = String(symbol).trim().toUpperCase();

    // typische Aktien: 3-5 Zeichen
    if (s.length < 3 || s.length > 5) return false;

    if (!/^[A-Z]+$/.test(s)) return false;

    return true;
}

export function getDisplaySymbol(value) {
    return normalizeSymbol(value);
}

export function getLookupSymbol(value) {
    const normalized = normalizeSymbol(value);
    if (!normalized) return null;

    // entfernt .DE / .US etc
    const base = normalized.split(/[.-]/)[0] || null;

    if (!base || base.length < 3) return null;

    return base;
}

export function getItemSymbol(item) {
    return getDisplaySymbol(
        item?.symbol ||
        item?.ticker ||
        item?.Symbol ||
        item?.Ticker ||
        item?.stockSymbol ||
        item?.isinSymbol ||
        null
    );
}

export function getNewsSymbol(news) {
    return getDisplaySymbol(
        news?.symbol ||
        news?.ticker ||
        news?.Symbol ||
        news?.Ticker ||
        news?.stockSymbol ||
        news?.isinSymbol ||
        null
    );
}

export function getItemLookupSymbol(item) {
    return getLookupSymbol(
        item?.symbol ||
        item?.ticker ||
        item?.Symbol ||
        item?.Ticker ||
        item?.stockSymbol ||
        item?.isinSymbol ||
        null
    );
}

export function getNewsLookupSymbol(news) {
    return getLookupSymbol(
        news?.symbol ||
        news?.ticker ||
        news?.Symbol ||
        news?.Ticker ||
        news?.stockSymbol ||
        news?.isinSymbol ||
        null
    );
}